import { useState } from 'react';
import { Sheet } from '../components/Sheet.jsx';
import { num } from '../lib/format.js';

const SCHNELL = [1, 2, 5, 10, 20, 25, 50, 100];

/**
 * Menge wählen.
 * - modus 'auswahl': Menge für die Auswahl (gebucht wird erst mit «Speichern»); `gebucht` = schon auf dem Auftrag
 * - modus 'gesamt': exakte Gesamtmenge einer gebuchten Position
 */
export function MengeSheet({ artikel, current = 0, gebucht = 0, modus = 'gesamt', onSet, onClose }) {
  const [value, setValue] = useState(current ? String(current) : '');
  const parsed = Number(String(value).replace(',', '.'));
  const valid = value.trim() !== '' && Number.isFinite(parsed) && parsed >= 0 && parsed <= 100000;
  const ok = valid && parsed !== current && (current > 0 || parsed > 0);
  const auswahl = modus === 'auswahl';
  const einheit = artikel.einheit || 'Stk';

  const label = auswahl
    ? `Wie viel brauchst du? (${einheit})`
    : `Menge total auf diesem Auftrag (${einheit})${current ? ` – bisher ${num(current)}` : ''}`;
  const knopf = !valid || (!current && !parsed)
    ? 'Menge eingeben'
    : auswahl
      ? (current ? `${num(parsed)} ${einheit} übernehmen` : `${num(parsed)} ${einheit} auswählen`)
      : `${num(parsed)} ${einheit} übernehmen`;

  return (
    <Sheet title={artikel.titel} onClose={onClose}>
      {auswahl && gebucht > 0 && <p className="sub" style={{ fontWeight: 700 }}>Schon auf dem Auftrag: {num(gebucht)} {einheit} – die Menge hier kommt dazu.</p>}
      <label className="field">
        <span className="label">{label}</span>
        <input className="input tn" style={{ height: 60, fontSize: 28, fontWeight: 800 }} inputMode="decimal" value={value} placeholder="0" autoFocus
          onChange={(e) => setValue(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter' && ok) onSet(parsed); }} />
      </label>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: 6 }}>
        {SCHNELL.map((n) => <button key={n} className="chip tn" style={{ height: 46, borderRadius: 12 }} onClick={() => setValue(String(n))}>{n}</button>)}
      </div>
      <button className="btn lg block" disabled={!ok} onClick={() => onSet(parsed)}>{knopf}</button>
      {current > 0 && (
        <button className="btn secondary block" onClick={() => onSet(0)}>{auswahl ? 'Aus der Auswahl entfernen' : 'Position entfernen'}</button>
      )}
      {auswahl && <p className="sub" style={{ textAlign: 'center' }}>Gebucht wird erst mit «Speichern».</p>}
    </Sheet>
  );
}
